export default __webpack_public_path__ + "static/media/image1.f2045bd5.jpg";